import { EAuctionBiddingEngine } from '@bonhams1793/bonhams-typescript'
import { useEffect, useRef } from 'react'
import { Id } from 'react-toastify'

import { LostBiddingConnectionBanner } from '@nx/bidding-engine'
import { usePusher } from '@nx/external/pusher'
import { showToast } from '@nx/fire/toast'

export const useBiddingConnectionNotification = ({
  isAMConnected,
  biddingEngine,
}: useBiddingConnectionNotificationProps) => {
  const amToast = useRef<Id | null>(null)
  const bbeToast = useRef<Id | null>(null)
  const { pusherConnectionStatus } = usePusher()

  useEffect(() => {
    if (biddingEngine === 'AM') {
      if (!isAMConnected && !amToast.current) {
        amToast.current = showToast.error(<LostBiddingConnectionBanner />, {
          autoClose: false,
          icon: false,
          closeButton: false,
          toastId: 'am-connection-failed',
          className: 'notification-full-width',
        })
      } else if (isAMConnected && amToast.current) {
        showToast.dismiss(amToast.current)
        amToast.current = null
      }
    }
  }, [isAMConnected, biddingEngine])

  useEffect(() => {
    if (biddingEngine === 'bonhams_bidding_engine') {
      if (pusherConnectionStatus === 'DISCONNECTED' && !bbeToast.current) {
        bbeToast.current = showToast.error(<LostBiddingConnectionBanner />, {
          autoClose: false,
          icon: false,
          closeButton: false,
          toastId: 'bbe-connection-failed',
          className: 'notification-full-width',
        })
      } else if (pusherConnectionStatus === 'CONNECTED' && bbeToast.current) {
        showToast.dismiss(bbeToast.current)
        bbeToast.current = null
      }
    }
  }, [biddingEngine, pusherConnectionStatus])

  useEffect(() => {
    return () => {
      if (amToast.current) {
        showToast.dismiss(amToast.current)
        amToast.current = null
      }

      if (bbeToast.current) {
        showToast.dismiss(bbeToast.current)
        bbeToast.current = null
      }
    }
  }, [])
}

export interface useBiddingConnectionNotificationProps {
  isAMConnected?: boolean
  biddingEngine: EAuctionBiddingEngine | null
}
